import { render, staticRenderFns } from "./process-datasubject-bulk-remove-form.vue?vue&type=template&id=2a306ac1"
import script from "./process-datasubject-bulk-remove-form.vue?vue&type=script&lang=js"
export * from "./process-datasubject-bulk-remove-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports